import { create } from 'apisauce'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { saveAndSendAuthDataToExtension } from './auth0/useAuth0'

const BASE_URL = process.env.GATSBY_BASE_API_URL

const getHeaders = () => {
  const headersLocalStorage = JSON.parse(typeof window !== 'undefined' ? localStorage.getItem("underline") : "{}")
  if (headersLocalStorage) {
    return {
      'id_token': headersLocalStorage.idToken,
      'Authorization': `Bearer ${headersLocalStorage.accessToken}`
    }
  }
  return {}
}

export const useApiBase = () => {
  const api = create({
    headers: getHeaders(),
    timeout: 10000,
    baseURL: BASE_URL,
  });

  const refreshTokenAuthLogic = async (failedRequest) => {
    const oldAuthData = JSON.parse(localStorage.getItem("underline"))
    return refreshToken(oldAuthData.refreshToken).then(refreshedToken => {
        saveAndSendAuthDataToExtension(
          refreshedToken.data.access_token,
          refreshedToken.data.refresh_token,
          refreshedToken.data.expires_at || null,
          oldAuthData.idToken
        )
      api.setHeader('Authorization', `Bearer ${refreshedToken.data.access_token}`)
      failedRequest.response.config.headers['Authorization'] = `Bearer ${refreshedToken.data.access_token}`

      return Promise.resolve()
    })
  };

  createAuthRefreshInterceptor(api.axiosInstance, refreshTokenAuthLogic);

  const setHeader = (headerKey, headerValue) => api.setHeader(headerKey, headerValue)
  const setHeaders = (headers) => api.setHeaders(headers)
  const getUser = () => api.get('/api/v1/user')
  const updateSettings = (data) => api.post('/api/v1/user/settings?app=extension', data)
  const updateUserDetails = (data) => api.patch("/api/v1/user/details", data)
  const updateUser = (data) => api.patch('/api/v1/user', {
    learning_languages: data.learningLanguages,
    native_language: data.nativeLanguage,
    weekly_goal: data.weeklyGoal
  })
  const deleteUser = () => api.delete('/api/v1/user')

  const refreshToken = (token) => api.post('/public/token/refresh', {
    refresh_token: token
  })

  return {
    setHeaders,
    setHeader,
    getUser,
    updateUser: updateUser,
    updateSettings: updateSettings,
    updateUserDetails,
    refreshToken,
    deleteUser,
    instance: api
  }
}